import { Component, Input, OnInit } from '@angular/core';
import { DatabaseService } from '../providers/database.service';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})
export class ConfigComponent implements OnInit {

  @Input() mediatorInfo;

  streamList: any;
  selStream = {name: 'not yet'};
  inOne: string = "please select";
  inTwo: string = "please select";
  name: string = "";

  constructor(public db: DatabaseService) {
    var ref = db.getStreams();
    ref.on('value',
      snap => {
        var streamsObject = snap.val();
        this.streamList = Object.keys(streamsObject).map(
          key => {
            return streamsObject[key].name;
          }
        )
      });
  }

  ngOnInit() {
  }

  getStreams() {

    return this.streamList;

  }

  notConfigured() {
    if (this.inOne === "please select") return true;
    if (this.inTwo === "please select") return true;
    if (this.name === "") return true;
    return false;
  }

  publish() {
    var streamInfo = {
      name: this.name,
      type: 'WebM',
      url: this.mediatorInfo.url,
      mediatorType: this.mediatorInfo.type,
      mediatorName: this.mediatorInfo.name,
      inputStreams: [this.inOne, this.inTwo]
    }
    this.db.addStream(streamInfo);
  }
}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/config/config.component.ts